<template>
  <div class="contact-page">
    <trsShopBreadcrumb
      class="contact-page__breadcrumb"
      :breadcrumbList="breadcrumbList"
      :skip="true"
    />
    <div class="contact-content">
      <ul class="contact-list">
        <li
          v-for="item in contactList"
          :key="item.title"
          class="contact-item"
        >
          <div class="contact-item__icon">
            <Icon :type="item.icon" size="32" color="#89b92a"/>
          </div>
          <div class="contact-item__body">
            <p class="contact-item__title">{{ item.title }}</p>
            <a
              v-if="item.link"
              :href="item.link"
              class="contact-item__value contact-item__value--link"
            >{{ item.value }}</a>
            <span v-else class="contact-item__value">{{ item.value }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import trsShopBreadcrumb from '@/components/layout/shopping/breadcrumb.vue';

export default {
  name: 'trsContact',
  mixins: [Mixin],
  components: {
    trsShopBreadcrumb
  },
  data() {
    let v = this;
    return {
      breadcrumbList: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562'),
          path: '/index'
        },
        {
          name: 'CONTACT',
          path: '/trsContact'
        }
      ],
      contactList: [
        {
          title: 'Call Us',
          value: '+86-0510-88532933',
          icon: 'ios-call',
          link: 'tel:+8651088532933'
        },
        {
          title: 'Phone',
          value: '+86 182 6158 7952',
          icon: 'ios-phone-portrait',
          link: 'tel:+8618261587952'
        },
        {
          title: 'Email',
          value: 'sales@tarazon.cn',
          icon: 'ios-mail',
          link: 'mailto:sales@tarazon.cn'
        },
        {
          title: 'Address',
          value: 'Founder Industrial Park, No. 162, Donglang Road, Yangjian Town, Xishan District, Wuxi City',
          icon: 'ios-pin'
        }
      ]
    };
  },
};
</script>

<style scoped lang="less">
.contact-page {
  width: 1200px;
  margin: 0 auto;
}

.contact-page__breadcrumb {
  margin: 0 auto;
  width: 1200px;
}

.contact-content {
  background-color: #ffffff;
  margin-bottom: 20px;
  padding: 32px 40px 40px;
  color: #333;
  font-family: Arial, 'Microsoft YaHei', sans-serif;
}

.contact-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 36px;

  &:last-child {
    margin-bottom: 0;
  }
}

.contact-item__icon {
  flex-shrink: 0;
  width: 40px;
  margin-right: 24px;
  line-height: 1;
}

.contact-item__body {
  flex: 1;
  min-width: 0;
  padding-top: 2px;
}

.contact-item__title {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 700;
  color: #000;
  line-height: 1.4;
}

.contact-item__value {
  display: block;
  font-size: 14px;
  color: #333;
  line-height: 1.7;
  word-break: break-word;
}

.contact-item__value--link {
  color: #333;
  text-decoration: none;

  &:hover {
    color: #89b92a;
    text-decoration: underline;
  }
}
</style>
